
import cornerstoneTools from 'cornerstone-tools';
// Drawing
const BaseAnnotationTool = cornerstoneTools.importInternal('base/BaseAnnotationTool');

//const getToolState = cornerstoneTools.importInternal('stateManagement/toolState');
//const toolStyle = cornerstoneTools.importInternal('stateManagement/toolStyle');

//const toolColors = cornerstoneTools.importInternal('stateManagement/toolColors');

const draw = cornerstoneTools.importInternal('drawing/draw');
const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
const drawLine = cornerstoneTools.importInternal('drawing/drawLine');
const getNewContext = cornerstoneTools.importInternal('drawing/getNewContext');
const drawLinkedTextBox = cornerstoneTools.importInternal('drawing/drawLinkedTextBox');
const drawHandles = cornerstoneTools.importInternal('drawing/drawHandles');
const lineSegDistance = cornerstoneTools.importInternal('util/lineSegDistance');

const getLogger = cornerstoneTools.importInternal('util/getLogger');
const getPixelSpacing = cornerstoneTools.importInternal('util/getPixelSpacing');
const throttle = cornerstoneTools.import('util/throttle');
const getModule = cornerstoneTools.importInternal('store/index');


const lengthCursor = cornerstoneTools.importInternal('cursors/index');



//const fillTextLines = cornerstoneTools.importInternal('drawing/fillTextLines');
// NOTE: if you're creating a tool inside the CornerstoneTools repository
// you can import BaseTool directly from `src/tools/base`.

// export default class HelloWorldTool extends BaseTool {
//     constructor(name = 'HelloWorld') {
//         super({
//             name,
//             supportedInteractionTypes: ['Mouse'],
//         });
//     }
// }



//const logger = getLogger('tools:annotation:LengthTool');

/**
 * @public
 * @class LengthTool
 * @memberof Tools.Annotation
 * @classdesc Tool for measuring distances.
 * @extends Tools.Base.BaseAnnotationTool
 */
export default class LengthToolEyonix extends BaseAnnotationTool {

    constructor(props = {}) {
        const defaultProps = {
            name: 'Length',
            supportedInteractionTypes: ['Mouse', 'Touch'],
            svgCursor: lengthCursor,
            configuration: {
                drawHandles: true,
                drawHandlesOnHover: false,
                hideHandlesIfMoving: false,
                renderDashed: false,
                digits: 2,
            },
        };

        super(props, defaultProps);

        this.throttledUpdateCachedStats = throttle(this.updateCachedStats, 110);
    }

    createNewMeasurement(eventData) {

        const goodEventData =
            eventData && eventData.currentPoints && eventData.currentPoints.image;

        if (!goodEventData) {
            // logger.error(
            //     `required eventData not supplied to tool ${this.name}'s createNewMeasurement`
            // );

            return;
        }

        const { x, y } = eventData.currentPoints.image;

        return {
            visible: true,
            active: true,
            color: undefined,
            invalidated: true,
            fontSize: undefined,
            textVisible: undefined,
            who: undefined,
            when: undefined,
            whenStr: undefined,
            handles: {
                start: {
                    x,
                    y,
                    highlight: true,
                    active: false,
                },
                end: {
                    x,
                    y,
                    highlight: true,
                    active: true,
                },
                textBox: {
                    active: false,
                    hasMoved: false,
                    movesIndependently: false,
                    drawnIndependently: true,
                    allowedOutsideImage: true,
                    hasBoundingBox: true,
                },
            },
        };
    }

    /**
     *
     *
     * @param {*} element
     * @param {*} data
     * @param {*} coords
     * @returns {Boolean}
     */
    pointNearTool(element, data, coords) {
        const hasStartAndEndHandles =
            data && data.handles && data.handles.start && data.handles.end;
        const validParameters = hasStartAndEndHandles;

        if (!validParameters) {
            // logger.warn(
            //     `invalid parameters supplied to tool ${this.name}'s pointNearTool`
            // );

            return false;
        }

        if (data.visible === false) {
            return false;
        }

        return (
            lineSegDistance(element, data.handles.start, data.handles.end, coords) <
            25
        );
    }

    updateCachedStats(image, element, data) {
        // const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);
        const rowPixelSpacing = image ? image.rowPixelSpacingEx : undefined;
        const colPixelSpacing = image ? image.columnPixelSpacingEx : undefined;

        // Set rowPixelSpacing and columnPixelSpacing to 1 if they are undefined (or zero)
        const dx =
            (data.handles.end.x - data.handles.start.x) * (colPixelSpacing || 1);
        const dy =
            (data.handles.end.y - data.handles.start.y) * (rowPixelSpacing || 1);

        // Calculate the length, and create the text variable with the millimeters or pixels suffix
        const length = Math.sqrt(dx * dx + dy * dy);

        // Store the length inside the tool for outside access
        data.length = length;
        data.invalidated = false;
    }

    renderToolData(evt) {
      //  console.log(this.options.test);

        const eventData = evt.detail;
        const {
            handleRadius,
            drawHandlesOnHover,
            hideHandlesIfMoving,
            renderDashed,
            digits,
        } = this.configuration;
        const toolData = cornerstoneTools.getToolState(evt.currentTarget, this.name);

        if (!toolData) {
            return;
        }

        // We have tool data for this element - iterate over each one and draw it
        const context = getNewContext(eventData.canvasContext.canvas);
        const { image, element } = eventData;
        // const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);
        const rowPixelSpacing = image ? image.rowPixelSpacingEx : undefined;
        const colPixelSpacing = image ? image.columnPixelSpacingEx : undefined;

        const lineWidth = cornerstoneTools.toolStyle.getToolWidth();
        const lineDash = cornerstoneTools.getModule('globalConfiguration').configuration.lineDash;

//const hideHandlers = eventData.viewport.hideHanders || false;

        for (let i = 0; i < toolData.data.length; i++) {
            const data = toolData.data[i];

            if (data.visible === false) {
                continue;
            }

            draw(context, context => {
                // Configurable shadow
                setShadow(context, this.configuration);

                var color = cornerstoneTools.toolColors.getColorIfActive(data);
                color = color.hasOwnProperty('main')? color['main']: color;

                data.color = data.color || cornerstoneTools.toolColors.getToolColor(data);

                let initFontSize = cornerstoneTools.textStyle.getFontSize();

                data.fontSize = data.fontSize !== undefined? data.fontSize : cornerstoneTools.textStyle.getFontSize();
                data.textVisible = data.textVisible !== undefined? data.textVisible : this.options.annotationTextVisible;

                if(data.invalidated && (data.who !== this.initialConfiguration.user || data.when !== new Date().toLocaleString())) {
                    data.who = this.initialConfiguration.user;
                    data.when = new Date().toLocaleString();
                    if(this.initialConfiguration.momentLib && this.initialConfiguration.defaultDateTimeFormat) {
                        data.whenStr = this.initialConfiguration.momentLib().format(this.initialConfiguration.defaultDateTimeFormat);
                    } else {
                        data.whenStr = new Date().toLocaleString();
                    }
                }


                cornerstoneTools.textStyle.setFont(`${data.fontSize}px Roboto`);
                cornerstoneTools.textStyle.setFontSize(data.fontSize);

                const lineOptions = { color };

                if (renderDashed) {
                    lineOptions.lineDash = lineDash;
                }

                // Draw the measurement line
                drawLine(
                    context,
                    element,
                    data.handles.start,
                    data.handles.end,
                    lineOptions
                );

                // Draw the handles
                const handleOptions = {
                    color,
                    handleRadius,
                    drawHandlesIfActive: drawHandlesOnHover,
                    hideHandlesIfMoving,
                };

                if (data.active) {
                    drawHandles(context, eventData, data.handles, handleOptions);
                }


                if (!data.handles.textBox.hasMoved) {
                    const coords = {
                        x: Math.max(data.handles.start.x, data.handles.end.x),
                    };

                    // Depending on which handle has the largest x-value,
                    // Set the y-value for the text box
                    if (coords.x === data.handles.start.x) {
                        coords.y = data.handles.start.y;
                    } else {
                        coords.y = data.handles.end.y;
                    }

                    data.handles.textBox.x = coords.x;
                    data.handles.textBox.y = coords.y;
                }

                // Move the textbox slightly to the right and upwards
                // So that it sits beside the length tool handle
                const xOffset = 10;

                // Update textbox stats
                if (data.invalidated === true) {
                    if (data.length) {
                        this.throttledUpdateCachedStats(image, element, data);
                    } else {
                        this.updateCachedStats(image, element, data);
                    }
                }

                const text = textBoxText(data, rowPixelSpacing, colPixelSpacing);
                const tooltipText =  `${data.who} (${data.whenStr})` ;


                if((data.active || this.options.showUser) && data.who) {
                    drawLinkedTextBox(
                        context,
                        element,
                        {
                            x: data.handles.end.x - (data.handles.end.x - data.handles.start.x)/2,
                            y: data.handles.end.y - (data.handles.end.y - data.handles.start.y)/2,
                        },
                        tooltipText,
                        data.handles,
                        textBoxAnchorPoints,
                        "white",
                        lineWidth,
                        xOffset,
                        false
                    );
                }


                if(data.textVisible) {
                    drawLinkedTextBox(
                        context,
                        element,
                        data.handles.textBox,
                        text,
                        data.handles,
                        textBoxAnchorPoints,
                        //color,
                        "white",
                        lineWidth,
                        xOffset,
                        true
                    );
                }

                cornerstoneTools.textStyle.setFontSize(initFontSize);
                cornerstoneTools.textStyle.setFont(`${initFontSize}px Roboto`);

            });
        }

        // - SideEffect: Updates annotation 'suffix'
        function textBoxText(annotation, rowPixelSpacing, colPixelSpacing) {
            const measuredValue = _sanitizeMeasuredValue(annotation.length);

            // Measured value is not defined, return empty string
            if (!measuredValue) {
                return '';
            }

            // Set the length text suffix depending on whether or not pixelSpacing is available
            let suffix = 'mm';

            if (!rowPixelSpacing || !colPixelSpacing) {
                suffix = 'pixels';
            }

            annotation.unit = suffix;

            return `${measuredValue.toFixed(digits)} ${suffix}`;
        }

        function textBoxAnchorPoints(handles) {
            const midpoint = {
                x: (handles.start.x + handles.end.x) / 2,
                y: (handles.start.y + handles.end.y) / 2,
            };

            return [handles.start, midpoint, handles.end];
        }
    }
}

/**
 * Attempts to sanitize a value by casting as a number; if unable to cast,
 * we return `undefined`
 *
 * @param {*} value
 * @returns a number or undefined
 */
function _sanitizeMeasuredValue(value) {
    const parsedValue = Number(value);
    const isNumber = !isNaN(parsedValue);

    return isNumber ? parsedValue : undefined;
}